var Event = new Object();

Event.viewEventPopup = function(eventId) {
    Util.showPopup('/events/viewEventPopup?eventId=' + eventId);
}

Event.showRegistrationClosedPopup = function(isStandby) {
    if (isStandby) {
        Util.showPopupAlert('Standby only. Reservations no longer available.', 'This event is closed.<br><br>If you would like to attend, you can join the standby list. <br><br>' +
            'Simply show up 45 minutes prior to the event. Committee members checking in at the door will begin creating a standby list on a first-come-first-served basis.<br><br>' +
            'As seats become available, standbys will be admitted in the order in which they appear on the list.');
    } else {
        Util.showPopupAlert('Event closed. No standby.', 'This event is sold out and the wait list is no longer in effect.  Please note that there is no standby option for this event.');
    }
}

/**
 * Function to calculate the cancellation date for an event date
 */
Event.getCancellationDateForEventDate = function(eventDate) {
    var testDate = new Date();
    testDate.setYear(2026);
    testDate.setMonth(6); // 0-based!!!
    testDate.setDate(3);
    if (eventDate > testDate) {
        alert('The latest club holidays need to be added to the site.  Until then, cancellation dates for events after July 3, 2026 will not automatically consider club holidays.  Please send the latest dates to the website developer to add to the site.');
    }

    var cancellationDate = new Date();
    cancellationDate.setTime(eventDate.valueOf());
    cancellationDate.setDate(cancellationDate.getDate() - 3); // JG 6/3: 2 complete business days, plus the morning before the event
    var tempDate = new Date();
    tempDate.setTime(eventDate.valueOf());
    var numDays = 0;
    //alert('cancellation: ' + cancellationDate + ' tempDate: ' + tempDate + ' event date: ' + eventDate);
    while (tempDate >= cancellationDate) {
        //alert(" is " + tempDate + " a holiday ? " + isWeekendOrHoliday(tempDate));
        if (Event.isWeekendOrHoliday(tempDate)) {
            cancellationDate.setDate(cancellationDate.getDate() - 1);
        }
        tempDate.setDate(tempDate.getDate() - 1);
    }
    //alert('cancellation date:' + cancellationDate);
    return cancellationDate;
}


Event.isWeekendOrHoliday = function(dateToTest) {
    return Event.isWeekend(dateToTest) || Event.isHoliday(dateToTest);
}
Event.isNotSatOrHoliday = function(dateToTest) {
    return Event.isNotSat(dateToTest) || Event.isHoliday(dateToTest);
}


/**
 * Function to test if the passed in date is a weekend
 */
Event.isWeekend = function(dateToTest) {
    if (dateToTest.getDay() == 0 || dateToTest.getDay() == 6) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * Function to test if the passed in date is not a Saturday
 */
 Event.isNotSat = function(dateToTest) {
    if (dateToTest.getDay() != 6) {
        return true;
    }
    else {
        return false;
    }
}


/**
 * Function to test if the passed in date is a holiday
 */
Event.isHoliday = function(dateToTest) {
    
    var strDateToTestFull = dateToTest.getFullYear() + '-' + (1 + dateToTest.getMonth()) + '-' + dateToTest.getDate();
    var strDateToTest = (1 + dateToTest.getMonth()) + '-' + dateToTest.getDate();

    if (strDateToTest == '12-25' ||
        strDateToTest == '1-1' ||
        strDateToTest == '7-4' ||
        /*
        strDateToTestFull == '2018-3-30' || // fri before easter
        strDateToTestFull == '2018-4-1' || // easter
        strDateToTestFull == '2018-5-28' || // memorial
        strDateToTestFull == '2018-7-4' || // independence
        strDateToTestFull == '2018-9-3' || // labor day
        strDateToTestFull == '2018-10-8' || // columbus
        strDateToTestFull == '2018-11-22' || // thanksgiving
        strDateToTestFull == '2018-11-23' || // day after t-day
        strDateToTestFull == '2018-12-24' || // christmas eve
        strDateToTestFull == '2018-12-25' || // christmas

        strDateToTestFull == '2019-1-1' || // new years
        strDateToTestFull == '2019-1-21' || // mlk
        strDateToTestFull == '2019-2-18' || // presidents day
        strDateToTestFull == '2019-4-19' || // friday before easter
        strDateToTestFull == '2019-4-21' || // easter
        strDateToTestFull == '2019-5-27' || // memorial day
        strDateToTestFull == '2019-7-4' || // independence day
        strDateToTestFull == '2019-7-5' || // veterans day observed
        strDateToTestFull == '2019-9-2' || // labor day
        strDateToTestFull == '2019-10-14' || // columbus day
        strDateToTestFull == '2019-11-28' || // thanksgiving
        strDateToTestFull == '2019-11-29' || // day after thanksgiving
        strDateToTestFull == '2019-12-25' || // christmas

        strDateToTestFull == '2020-1-1' || // new years
        strDateToTestFull == '2020-1-20' || // mlk
        strDateToTestFull == '2020-2-17' || // presidents day
        strDateToTestFull == '2020-4-10' || // good friday
        strDateToTestFull == '2020-4-12' || // easter
        strDateToTestFull == '2020-5-25' || // memorial day
        strDateToTestFull == '2020-7-3' || // independence day observed
        strDateToTestFull == '2020-9-7' || // labor day
        strDateToTestFull == '2020-10-12' || // columbus day
        strDateToTestFull == '2020-11-26' || // Thanksgiving  day
        strDateToTestFull == '2020-11-27' || // day after Thanksgiving  day
        strDateToTestFull == '2020-12-25' || // christmas  day

        strDateToTestFull == '2021-1-1' || // new year's  day
        strDateToTestFull == '2021-1-18' || // mlk day
        strDateToTestFull == '2021-2-15' || // president's day
        strDateToTestFull == '2021-4-2' || // good friday
        strDateToTestFull == '2021-4-4' || // easter day
        strDateToTestFull == '2021-5-31' || // memorial day
        strDateToTestFull == '2021-7-5' || // independence day observed
        strDateToTestFull == '2021-9-6' || // labor day
        strDateToTestFull == '2021-9-7' || // club closed
        strDateToTestFull == '2021-10-11' || // columbus day
        strDateToTestFull == '2021-11-25' || // Thanksgiving  day
        strDateToTestFull == '2021-11-26' || // day after Thanksgiving  day
        strDateToTestFull == '2021-12-24' || // christmas  day
        strDateToTestFull == '2021-12-31' || // new year's day observed

        strDateToTestFull == '2022-1-17' || // mlk day
        strDateToTestFull == '2022-2-21' || // president's day
        strDateToTestFull == '2022-4-15' || // good friday
        strDateToTestFull == '2022-5-30' || // memorial day
        strDateToTestFull == '2022-6-20' || // day after juneteenth
        strDateToTestFull == '2022-7-4' || // independence day
        strDateToTestFull == '2022-9-5'  || // labor day
        strDateToTestFull == '2022-10-10' || // columbus day
        strDateToTestFull == '2022-11-11' || // veterans day
        strDateToTestFull == '2022-11-24' || // thanksgiving day
        strDateToTestFull == '2022-11-25' || // day after thanksgiving
        strDateToTestFull == '2022-12-25' || // christmas day
        strDateToTestFull == '2022-12-26' || // christmas day observed
        */
        strDateToTestFull == '2023-1-2'   || // new year's day observed
        strDateToTestFull == '2023-1-16'  || // mlk day
        strDateToTestFull == '2023-2-20'  || // president's day
        strDateToTestFull == '2023-4-7'  || // good friday
        strDateToTestFull == '2023-4-9'  || // easter
        strDateToTestFull == '2023-5-29'  || // memorial day
        strDateToTestFull == '2023-6-19'  || // juneteenth
        strDateToTestFull == '2023-7-4'  || // independence day
        strDateToTestFull == '2023-9-4'  || // labor day
        strDateToTestFull == '2023-10-9'  || // columbus day
        strDateToTestFull == '2023-11-10'  || // veterans day
        strDateToTestFull == '2023-11-23'  || // thanksgiving day
        strDateToTestFull == '2023-11-24'  || // day after thanksgiving
        strDateToTestFull == '2023-12-25'  || // christmas day

        strDateToTestFull == '2024-1-1'    || // new years day
        strDateToTestFull == '2024-1-15'  || // martin luther king jr day
        strDateToTestFull == '2024-2-19'  || // presidents day
        strDateToTestFull == '2024-3-29'  || // good friday
        strDateToTestFull == '2024-3-31'  || // easter
        strDateToTestFull == '2024-5-27'  || // memorial day
        strDateToTestFull == '2024-6-19'  || // juneteenth
        strDateToTestFull == '2024-7-4'   || // independence day
        strDateToTestFull == '2024-9-2'  || // labor day
        strDateToTestFull == '2024-10-14'  || // columbus day
        strDateToTestFull == '2024-11-11'  || // veterans day
        strDateToTestFull == '2024-11-28'  || // thanksgiving day 
        strDateToTestFull == '2024-11-29'  || // day after thanksgiving
        strDateToTestFull == '2024-12-25'  || // christmas day

        strDateToTestFull == '2025-1-1'  || // new years day
        strDateToTestFull == '2025-1-20'  || // martin luther king jr day
        strDateToTestFull == '2025-2-17'  || // presidents day
        strDateToTestFull == '2025-4-18'  || // good friday
        strDateToTestFull == '2025-4-20'  || // easter
        strDateToTestFull == '2025-5-26'  || // memorial day
        strDateToTestFull == '2025-6-19'  || // juneteenth
        strDateToTestFull == '2025-7-4'   || // independence day
        strDateToTestFull == '2025-9-1'   || // labor day
        strDateToTestFull == '2025-10-13' || // columbus day
        strDateToTestFull == '2025-11-27' || // thanksgiving day
        strDateToTestFull == '2025-11-28' || // day after thanksgiving
        strDateToTestFull == '2025-12-25' || // christmas day
        strDateToTestFull == '2025-12-26' || // day after christmas
        strDateToTestFull == '2026-1-1'   || // new years day
        strDateToTestFull == '2026-1-19'  || // mlk day
        strDateToTestFull == '2026-2-16'  || // presidents day
        strDateToTestFull == '2026-4-3'   || // good friday
        strDateToTestFull == '2026-4-5'   || // easter
        strDateToTestFull == '2026-5-25'  || // memorial day
        strDateToTestFull == '2026-6-19'  || // juneteenth
        strDateToTestFull == '2026-7-3'   // independence day observed

    ) {
        //console.log("FOUND : " + strDateToTestFull + " is a holiday." );
        return true;
    }
    return false;
}

/**
 * show the popup with cancellation choices
 * optionally pass in which page to end up on after cancelling the reservation
 */
Event.cancelReservation = function(eventReservationId, strFinalPage) {
    Util.showPopup('/events/cancelEventReservationPopup?eventReservationId=' + eventReservationId + '&finalPage=' + strFinalPage);
}

/**
 * show the popup with cancellation choices
 * optionally pass in which page to end up on after cancelling the reservation
 */
Event.cancelBuffetReservation = function(eventReservationId) {
    Util.confirm('Are you sure you want to cancel your buffet reservation?  Your event reservation will not be canceled.', function() {
        Util.submitForm({
            bPopup: true,
            bValidate: false,
            strURL: '/events/cancelEventBuffetReservation?eventReservationId=' + eventReservationId,
            strFormName: 'frmPopup',
            fnClearErrors: function() { Util.clearErrors(true); },
            fnOnInvalid: function(strValidationMessage) {
                $('.divErrorPopup').html(strValidationMessage).show();
            },
            fnOnSuccess: function(strHtml) {
                Util.onAjaxSuccess(strHtml, function() {
                    Util.refreshPage();
                });
            }
        });
    });
}

Event.cancelAdminEventReservation = function(eventReservationId) {
    // if the cancellation date has passed and the event is not free, show a special popup with options:  
    Util.showPopup('/admin/events/cancelEventReservationPopup?eventReservationId=' + eventReservationId, 500);
}

Event.cancelAdminEventBuffetReservation = function() {
    //
    Util.confirm('Are you sure you want to cancel the buffet reservation?  The event reservation will not be canceled.', function() {
        Util.doAction('/admin/events/doCancelEventBuffetReservation');
    });
}


/**
 * used to show the popup list of event registrations
 */
Event.viewEventRegistrations = function(eventId) {
    Util.showPopup('/events/viewPublicEventReservationList?eventId=' + eventId, 500);
}

Event.createReservation = function(eventId) {
    Util.showPopup('/events/createEventReservation?fromSite=true&eventId=' + eventId, 900, 'divPopup', true);
}

Event.editReservation = function(eventId, eventReservationId) {
    //Util.showPopup('/events/editEventReservation?eventId='+eventId + '&eventReservationId=' + eventReservationId,700,'divPopup',true);
    doAction('/events/editEventReservation');
}


/**
 * used to show the popup list of event buffet registrations
 */
 Event.viewEventBuffetRegistrations = function(eventId) {
    Util.showPopup('/events/viewPublicEventBuffetReservationList?eventId=' + eventId, 500);
}

// used in the CosWeb pages and nav
Event.shareEvents = function() {
    Util.showPopup('/events/friendLists/shareEvents', 650);
}
Event.shareEvent = function(eventId) {
    if (eventId === undefined) { return Event.shareEvents(); }
    Util.showPopup('/events/friendLists/shareEvents?eventId=' + eventId, 650);
}
Event.shareClass = function(courseSessionId) {
    if (courseSessionId === undefined) { return Event.shareEvents(); }
    Util.showPopup('/events/friendLists/shareEvents?courseSessionId=' + courseSessionId, 650);
}

/**
 * strFromPage: nothing, or fromShareEvents
 * eventId: nothing, or the event id - if sharing just one event
 */
Event.createFriendList = function(strFromPage, eventId) {
    var strUrl = '/create';
    if (strFromPage !== undefined) {
        strUrl += '?' + strFromPage + '=true' + '&eventId=' + eventId;
    }
    Util.showPopup('/events/friendLists' + strUrl, 600);
}

/**
 * strFromPage: nothing, or fromShareEvents
 * eventId: nothing, or the event id - if sharing just one event
 */
Event.editFriendList = function(friendListId, strFromPage, eventId) {
    var strUrl = '/edit';
    if (strFromPage !== undefined) {
        strUrl += '?' + strFromPage + '=true' + '&eventId=' + eventId;
    }
    Util.showPopup('/events/friendLists/' + friendListId + strUrl, 600, 'divPopup', false);
}

Event.deleteFriendList = function(friendListId) {
    Util.confirm('Are you sure you want to delete this list?', function() {
        Util.doAction('/events/friendLists/' + friendListId + '/delete');
    });
}

var Course = new Object();

Course.deleteSession = function(sessionId, fromPage) {
    //alert('fromPage: ' + fromPage);
    Util.confirm('You are about to delete this class session.  By doing so, you will launch an email to every registrant telling them that the Class is cancelled. * If this is your intention, click "Yes."  If this is not your intention, click "No."',
        function() {
            Util.doAction('/admin/classes/classSessions/' + sessionId + '/delete/' + fromPage);
        });
}

Course.createReservation = function(courseSessionId) {

    //do ajax call to see if physical class waiver needs to be signed first
    $.ajax({
        type: 'POST',
        url: '/events/validatePhysicalClassWaiver',
        data: { courseSessionId: courseSessionId },
        success: function(strJson) {
            console.log('result: ' + strJson);
            var objResult = JSON.parse(strJson);
            if (objResult.status == 'PASS') {
                Util.doAction('/events/createClassReservation?fromSite=true&courseSessionId=' + courseSessionId);
            } else {
                Util.showPopup('/events/physicalWaiver/requiredForCourseSession?fromSite=true&courseSessionId=' + courseSessionId, 900, 'divPopup', true);
            }
        },
        error: function(strJson) {
            console.log('result: ' + strJson);
            Util.showPopupAlert('System Error', 'An unknown error occurred');
        }
    });
}


function Guest(objToCopy) {
    if (objToCopy !== undefined) {
        for (p in objToCopy) {
            this[p] = objToCopy[p];
        }
    }
}

Guest.fromString = function(theString) {
    var guest = new Guest(JSON.parse(theString));
    return guest;
}

Guest.prototype.fromForm = function(theForm) {
    this.guestId = theForm.guestId.value;
    this.memberId = -1; //not used: theForm.memberId.value;
    this.title = theForm.title.value;
    this.firstName = theForm.firstName.value;
    this.lastName = theForm.lastName.value;
    this.email = theForm.email.value;
    this.isChild = (theForm.child && theForm.child.checked ? 'Y' : 'N');
    this.childAge = (theForm.childAge ? theForm.childAge.value : 0);
    if (theForm.ALL_HIDDEN_FIELDS && (theForm.ALL_HIDDEN_FIELDS != null) && ('true' == theForm.ALL_HIDDEN_FIELDS.value)) {
        this.isMember = theForm.isMember.value;
        this.isFallGuest = theForm.isFallGuest.value;
    } else {
        this.isMember = getCheckedRadio('isMember', theForm) == 'Y';
        this.isFallGuest = getCheckedRadio('isMember', theForm) == 'FG';
    }
}

Guest.prototype.toValString = function() {
    return this.toString();
    //return this.guestId+' ~ '+this.title+' ~ '+this.firstName+' ~ '+this.lastName+' ~ '+ this.email+' ~ '+this.isMember+' ~ '+this.isFallGuest +' ~ '+this.isChild + ' ~ ' + this.memberId;
}

Guest.prototype.toJSONString = function() {
    return JSON.stringify(this);
}

Guest.prototype.toString = function() {
    return '{guestId:\'' + this.guestId +
        '\',title:\'' + this.title +
        '\',firstName:\'' + Util.escapeQuote(this.firstName) +
        '\',lastName:\'' + Util.escapeQuote(this.lastName) +
        '\',email:\'' + Util.escapeQuote(this.email) +
        '\',isMember:\'' + this.isMember +
        '\',isFallGuest:\'' + this.isFallGuest +
        '\',chargeAccount:\'' + this.chargeAccount +
        '\',isChild:\'' + this.isChild +
        '\',childAge:\'' + this.childAge +
        '\',memberId:\'' + this.memberId + '\'}';
}

Guest.prototype.toTextString = function() {
    //alert('toTextString');
    return (this.title == '' ? '' : this.title + ' ') + this.firstName + ' ' + this.lastName + ' - Non-member' + (this.isChild == 'Y' ? ' (child)' : '') + (this.chargeAccount == 'Y' ? ', Account Charged' : '');
}

/**
 * expects a string[] of the values (the old way)
 */
Guest.prototype.setValues = function(theVal) {
    return this.initValues(theVal);
    /*
      var vals = theVal.split(' ~ ');
      if (vals.length < 8) {
          //alert('wrong number of vals: ' + vals.length + ': ' + theVal);
      }
      this.guestId=vals[0];
      this.title=vals[1];
      this.firstName=vals[2];
      this.lastName=vals[3];
      this.email=vals[4];
      this.isMember=vals[5];
      this.isFallGuest=vals[6];
      this.isChild=vals[7];
      if (vals.length >= 9) {
          this.memberId=vals[8];
      } else {
          this.memberId = 0;
      }

      */
}

/**
 * expects values in a "map"/object form
 */
Guest.prototype.initValues = function(valMap) {
    //alert('initValues, options: ' + valMap);
    eval('var options = ' + valMap);
    //alert('options: ' + options);
    this.guestId = (options.guestId ? options.guestId : 0);
    this.title = options.title;
    this.firstName = options.firstName;
    this.lastName = options.lastName;
    this.email = options.email;
    this.isMember = options.isMember;
    //alert(options.isFallGuest + '?? ' + (options.isFallGuest ? 'Y' : 'N'));
    if (options.isFallGuest) {
        this.isFallGuest = options.isFallGuest;
    }
    this.chargeAccount = options.chargeAccount;
    this.isChild = options.isChild;
    if (options.memberId) {
        this.memberId = options.memberId;
    } else {
        this.memberId = 0;
    }
    //alert('final: ' + this.toValString());
}


Guest.removeGuest = function(lnkRemove, fieldPrefix) {
    var divGuests = $(lnkRemove).closest('div.divGuests');
    $(lnkRemove).closest('div.guestListing').remove();
    var numEnteredGuests = Guest.getEnteredGuestCount();
    if ($('#txtNumGuests').val() > numEnteredGuests) {
        Util.confirm('Do you want to update your guest count to match the number of guests you have entered?',
            function() {
                $('#txtNumGuests').val(numEnteredGuests);
            }
        );
    }
    if (divGuests.find('div.guestListing').size() == 0) {
        divGuests.find('div.noGuests').show();
    }

}

/**
 * params: fieldPrefix,membersOnly,fallGuest,reciprocal,childEvent
 * (COS-22) eventId
 */
Guest.showAddGuest = function(params) {
    // clear out validations from previous form
    Validator.clearValidations({ strFormName: 'frmGuest' });
    Util.showPopup('/events/addGuest?type=' + params.type + '&fieldPrefix=' + params.fieldPrefix + '&isMemberOnly=' + params.membersOnly + '&isMemberVisitorOnly=' + params.membersVisitorsOnly + '&isChildEvent=' + params.childEvent + '&isFallGuest=' + params.fallGuest + '&eventId=' + params.eventId + '&isReciprocal=' + params.reciprocal, 400, 'divGuestFormPopup', true, true);
}

Guest.addGuestFromForm = function(fieldPrefix, theForm) {
    var guest = new Guest();
    guest.fromForm(theForm);
    Guest.addGuestFromObj(fieldPrefix, guest);
    Guest.updateGuestCount();
}

Guest.addGuestFromObj = function(fieldPrefix, guest) {
    $('#divGuests' + fieldPrefix + ' .noGuests').hide();
    $('#divGuests' + fieldPrefix).append('<div class="guestListing guest">' + guest.toTextString() +
        '<a class="link" onclick="Guest.removeGuest(this,\'' + fieldPrefix + '\')"><img src="/images/icons/remove.gif" border="0" /></a>' +
        '<input type="hidden" name="' + fieldPrefix + 'guestJSON" value="' + guest.toValString() + '"/>' +
        '</div>');
}

Guest.doAddMember = function(fieldPrefix, memberId, memberName, bVisitor) {
    $('#divGuests' + fieldPrefix + ' .noGuests').hide();
    $('#divGuests' + fieldPrefix).append('<div class="guestListing member">' + memberName + ' - ' + (bVisitor ? 'Visitor' : 'Member') +
        '<a class="link" onclick="Guest.removeGuest(this)"><img src="/images/icons/remove.gif" border="0" /></a>' +
        '<input type="hidden" name="' + fieldPrefix + 'guestMemberId" value="' + memberId + '"/>' +
        '</div>');
    Guest.updateGuestCount();
}

/** when a guest is added, increase the number of guests if less than the number of entered guests */
Guest.updateGuestCount = function() {
    var numEnteredGuests = Guest.getEnteredGuestCount();
    if ($('#txtNumGuests').val() < numEnteredGuests) {
        $('#txtNumGuests').val(numEnteredGuests);
    }
}

Guest.getEnteredGuestCount = function(fieldPrefix) {
    return $('#divGuests' + (fieldPrefix === undefined ? '' : fieldPrefix)).find('div.guestListing').size();
}

Guest.showHideGuests = function() {
    if ($('input[name="hasGuests"]:checked').val() == 'true') {
        $('#divGuestDetails').show();
    } else {
        $('#divGuestDetails').hide();
    }
}
Guest.pickWithGuests = function() {
    $('input[name="hasGuests"]:eq(1)').click();
    Guest.showHideGuests();
}


Event.createMGEventReservation = function(memberGroupEventId) {
    Util.showPopup('/events/memberGroupEvent/' + memberGroupEventId + '/createReservation', 600, 'divPopup', true);
}

Event.editMGEventReservation = function(memberGroupEventId, reservationId) {
    Util.showPopup('/events/memberGroupEvent/' + memberGroupEventId + '/editReservation?memberGroupEventReservationId=' + reservationId, 600, 'divPopup', true);
}

Event.cancelMGEventReservation = function(memberGroupEventId, reservationId) {
    Util.confirm('Are you sure you want to cancel this reservation for you and any guests?', function() {
        $.ajax({
            type: 'POST',
            url: '/events/memberGroupEvent/' + memberGroupEventId + '/cancelReservation?memberGroupEventReservationId=' + reservationId,
            success: function(html) {
                Util.onAjaxSuccess(html, function() { Util.refreshPage(); });
            },
            error: Util.onAjaxError
        });
    });
}

Event.addEventDraftLecturingMember = function(eventDraftId,bPastEvent) {
	Util.showPopup('/events/drafts/' + eventDraftId + '/addEventDraftLecturingMember?pastEvent=' + bPastEvent,400);
}

Event.addEventDraftIntroducingMember = function(eventDraftId,bPastEvent) {
	Util.showPopup('/events/drafts/' + eventDraftId + '/addEventDraftIntroducingMember?pastEvent=' + bPastEvent,400);
}

/*
* strType = lecture or introduce
*/
Event.deleteEventDraftLecturingMember = function(memberId,eventDraftId,strType) {
    var label = (strType == 'lecture' ? 'lecturing member' : 'speaker introducer');
   Util.confirm('Are you sure you want to delete this ' + label + '?',function() {
       var arrData = {memberId:memberId,lectureType:(strType=='lecture' ? 'EVENT' : 'INTRODUCER')};
       $.ajax({type: 'POST',
           url: '/events/drafts/' + eventDraftId + '/deleteEventDraftLecturingMember',
           data: arrData,
           success: function(strHtml) {
               Util.onAjaxSuccess(strHtml,function() {
                   if (strType=='lecture') {
                       $('#divLecturingMembers').html(strHtml);
                   } else {
                       $('#divIntroducingMembers').html(strHtml);
                   }
               });
           },
           error: function() {
               $('.divError').html('The system encountered an error while trying to delete the ' + label + '.  Please refresh the page and try again.');
           }
       });
   });
}

Event.saveEventDraftLecturingMember = function(eventDraftId,strType) {
	Util.submitForm({
		bPopup:true,
		bValidate:true,
		strURL:'/events/drafts/' + eventDraftId + '/saveEventDraftLecturingMember',
		strFormName:'frmPopup',
		fnClearErrors:function() {Util.clearErrors(true);},
		fnOnInvalid:function(strValidationMessage) {
			$('.divErrorPopup').html(strValidationMessage);
			$('.divErrorPopup').show();
		},
		fnOnSuccess:function(strHtml) {
			Util.onAjaxSuccess(strHtml,function() {
				Util.closePopup();
				if (strType == 'lecture') {
					$('#divLecturingMembers').html(strHtml);
				} else {
					$('#divIntroducingMembers').html(strHtml);
				}
			});
		}
	});
}

Event.submitEventDraftForReview = function(eventDraftId) {

	Util.confirm('Are you sure you want to submit this draft for review?  Have you saved?',function() {

		Util.disableNewButton('#btnSubmitDraftForReview','Processing...');
		//ajax call
		var queryUrl = '/events/drafts/' + eventDraftId + '/doSubmitEventDraftForReview';

		console.log('query: ' + queryUrl);

		Util.submitForm({
				bPopup:true,
			bValidate:false,
			strURL: queryUrl,
			strFormName:'frmMain',
			fnOnError:function(response) {
				console.log('** RESPONSE **:' + response);
				var jsonResponse = JSON.parse(response);
				Util.enableNewButton('#btnSubmitDraftForReview','Submit for Review');
				Util.showPopupAlert('Error submitting draft for review',jsonResponse.message);
			},
			fnOnSuccess:function(response) {
				console.log('** RESPONSE **:' + response);
				var jsonResponse = JSON.parse(response);
				Util.enableNewButton('#btnSubmitDraftForReview','Submit for Review');
				if (jsonResponse.status == "SUCCESS") {
                    var infoMessage = encodeURI('The draft was successfully submitted for review.');
                    Util.doAction('/events/drafts/viewEventDrafts?infoMessage=' + infoMessage);
				}
				else {
					Util.showPopupAlert('Error submitting draft for review',jsonResponse.message);
				}
			}
		});
	});
}

Event.openEventDraftEmailEditor = function(eventDraftId,role,roleFound) {
    if (roleFound=='true') {
        Util.showPopup('/events/drafts/event'+role+'Email/create?eventDraftId=' + eventDraftId,600);
    }
    else {
        Util.showPopupAlert('Error retrieving user', 'There is currently no one assigned to this role.');
    }
}


